<script>
export default [
  {
    id: 1,
    name: " Affin Bank ",
    routing: " 100002322 ",
    ca: [{ exact: 12 }],
    sa: [{ exact: 12 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 12 }],
    hpAc: [{ exact: 12 }],
    deliveryChannel: " OTC, Internet, Desktop Banking "
  },
  {
    id: 2,
    name: " Affin Islamic Bank ",
    routing: " 100002322 ",
    ca: [{ exact: 12 }],
    sa: [{ exact: 12 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 12 }],
    hpAc: [{ exact: 12 }],
    deliveryChannel: " OTC, Internet, Desktop Banking "
  },
  {
    id: 3,
    name: " Agrobank ",
    routing: " 100033061 ",
    ca: [],
    sa: [{ exact: 16 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 17 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet, ATM "
  },
  {
    id: 4,
    name: " Al-Rajhi Banking & Investment Corporation ",
    routing: " 100003509 ",
    ca: [{ exact: 15 }],
    sa: [{ exact: 15 }],
    creditCardAc: [],
    chargeCardAc: [{ exact: 16 }],
    loadAc: [],
    hpAc: [],
    deliveryChannel: " OTC, Internet, Cash Management "
  },
  {
    id: 5,
    name: " Alliance Bank ",
    routing: " 100002128 ",
    ca: [{ exact: 15 }],
    sa: [{ exact: 15 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 15 }],
    hpAc: [{ exact: 15 }],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 6,
    name: " Alliance Islamic Bank ",
    routing: " 100002128 ",
    ca: [{ exact: 15 }],
    sa: [{ exact: 15 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 15 }],
    hpAc: [{ exact: 15 }],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 7,
    name: " Ambank ",
    routing: " 100002089 ",
    ca: [{ exact: 13 }],
    sa: [{ exact: 13 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 14 }],
    hpAc: [{ exact: 14 }],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 8,
    name: " AmIslamic Bank ",
    routing: " 100002089 ",
    ca: [{ exact: 13 }],
    sa: [{ exact: 13 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 13 }, { exact: 14 }],
    hpAc: [{ exact: 14 }],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 9,
    name: " Bank Islam ",
    routing: " 100002458 ",
    ca: [{ exact: 14 }],
    sa: [{ exact: 14 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 14 }],
    hpAc: [{ exact: 14 }],
    deliveryChannel: " OTC, Internet, Desktop Banking "
  },
  {
    id: 10,
    name: " Bank Kerjasama Rakyat Malaysia ",
    routing: " 100016020 ",
    ca: [{ exact: 12 }],
    sa: [{ exact: 12 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 12 }],
    hpAc: [{ exact: 12 }],
    deliveryChannel: " OTC, Internet, ATM, Desktop Banking "
  },
  {
    id: 11,
    name: " Bank Muamalat ",
    routing: " 100003415 ",
    ca: [{ exact: 14 }],
    sa: [{ exact: 14 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 14 }, { exact: 17 }],
    hpAc: [{ exact: 14 }, { exact: 17 }],
    deliveryChannel: " OTC, Internet, Desktop Banking "
  },
  {
    id: 12,
    name: " Bank of America ",
    routing: " 100002076 ",
    ca: [{ min: 5, max: 17 }],
    sa: [{ min: 5, max: 17 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 13,
    name: " Bank of China ",
    routing: " 100002429 ",
    ca: [{ exact: 13 }, { exact: 15 }],
    sa: [{ exact: 13 }, { exact: 15 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 14,
    name: " Bank of Tokyo-Mitsubishi UFJ ",
    routing: " 100002102 ",
    ca: [{ exact: 6 }],
    sa: [{ exact: 6 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 6 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 15,
    name: " Bank Simpanan Nasional ",
    routing: " 100016017 ",
    ca: [],
    sa: [{ exact: 16 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 15 }],
    hpAc: [{ exact: 15 }],
    deliveryChannel: " OTC, Internet, ATM, Corporate Systems "
  },
  {
    id: 16,
    name: " BNP Paribas ",
    routing: " 100002636 ",
    ca: [{ min: 6, max: 16 }],
    sa: [],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 16 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 17,
    name: " CIMB Bank ",
    routing: " 100002050 ",
    ca: [{ exact: 10 }, { exact: 14 }],
    sa: [{ exact: 10 }, { exact: 14 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 10 }, { exact: 14 }, { exact: 17 }],
    hpAc: [{ exact: 10 }, { exact: 12 }, { exact: 17 }],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 18,
    name: " CIMB Islamic Bank ",
    routing: " 100002050 ",
    ca: [{ exact: 10 }, { exact: 14 }],
    sa: [{ exact: 10 }, { exact: 14 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 10 }, { exact: 14 }, { exact: 17 }],
    hpAc: [{ exact: 10 }, { exact: 12 }, { exact: 17 }],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 19,
    name: " Citibank ",
    routing: " 100002173 ",
    ca: [
      { type: "personal", exact: 10 },
      { type: "corporate", min: 9, max: 16 }
    ],
    sa: [{ exact: 10 }],
    creditCardAc: [{ exact: 15 }, { exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ min: 10, max: 14 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 20,
    name: " Deutsche Bank ",
    routing: " 100002199 ",
    ca: [{ min: 10, max: 17 }],
    sa: [{ min: 10, max: 17 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ min: 10, max: 17 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 21,
    name: " Hong Leong Bank ",
    routing: " 100002241 ",
    ca: [{ exact: 11 }, { exact: 13 }],
    sa: [{ exact: 11 }, { exact: 13 }],
    creditCardAc: [{ exact: 15 }, { exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 11 }, { exact: 13 }],
    hpAc: [{ exact: 11 }, { exact: 13 }],
    deliveryChannel: " OTC, Internet, Corporate Desktop "
  },
  {
    id: 22,
    name: " Hong Leong Islamic Bank ",
    routing: " 100002241 ",
    ca: [{ exact: 11 }, { exact: 13 }],
    sa: [{ exact: 11 }, { exact: 13 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 11 }, { exact: 13 }],
    hpAc: [{ exact: 11 }, { exact: 13 }],
    deliveryChannel: " OTC, Internet, Corporate Desktop "
  },
  {
    id: 23,
    name: " HSBC Bank ",
    routing: " 100002225 ",
    ca: [
      { exact: 12 },
      { exact: 13 },
      { exact: 14 },
      { exact: 15 },
      { exact: 17 }
    ],
    sa: [{ exact: 12 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 12 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 24,
    name: " HSBC Amanah ",
    routing: " 100002225 ",
    ca: [
      { exact: 12 },
      { exact: 13 },
      { exact: 14 },
      { exact: 15 },
      { exact: 17 }
    ],
    sa: [{ exact: 12 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ min: 12, max: 14 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 25,
    name: " Industrial and Commercial Bank of China (ICBC) ",
    routing: " 100002597 ",
    ca: [{ exact: 17 }],
    sa: [{ exact: 17 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 17 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 26,
    name: " J.P. Morgan Chase ",
    routing: " 100002157 ",
    ca: [{ exact: 10 }],
    sa: [{ exact: 10 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 10 }],
    hpAc: [],
    deliveryChannel: " Internet "
  },
  {
    id: 27,
    name: " Kuwait Finance House ",
    routing: " 100003460 ",
    ca: [{ exact: 12 }],
    sa: [{ exact: 12 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 12 }],
    hpAc: [{ exact: 12 }],
    deliveryChannel: " OTC, Internet, ATM "
  },
  {
    id: 28,
    name: " Maybank ",
    routing: " 100002270 ",
    ca: [{ exact: 12 }],
    sa: [{ exact: 12 }],
    creditCardAc: [{ exact: 15 }, { exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 12 }],
    hpAc: [{ exact: 12 }],
    deliveryChannel: " OTC, Internet, Cash Mgmt, ATM "
  },
  {
    id: 29,
    name: " Maybank Islamic ",
    routing: " 100002270 ",
    ca: [{ exact: 12 }],
    sa: [{ exact: 12 }],
    creditCardAc: [{ exact: 15 }, { exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 12 }],
    hpAc: [{ exact: 12 }],
    deliveryChannel: " OTC, Internet, Cash Mgmt, ATM "
  },
  {
    id: 30,
    name: " Mizuho Bank ",
    routing: " 100002610 ",
    ca: [{ exact: 10 }],
    sa: [],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 31,
    name: " OCBC Bank ",
    routing: " 100002296 ",
    ca: [{ exact: 10 }],
    sa: [{ exact: 10 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 15 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet, Mobile Banking "
  },
  {
    id: 32,
    name: " OCBC Al-Amin Bank ",
    routing: " 100002296 ",
    ca: [{ exact: 10 }],
    sa: [{ exact: 10 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 15 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet, Mobile Banking "
  },
  {
    id: 33,
    name: " Public Bank ",
    routing: " 100002335 ",
    ca: [{ exact: 10 }],
    sa: [{ exact: 10 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 15 }],
    hpAc: [{ exact: 15 }],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 34,
    name: " Public Islamic Bank ",
    routing: " 100002335 ",
    ca: [{ exact: 10 }],
    sa: [{ exact: 10 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 15 }],
    hpAc: [{ exact: 15 }],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 35,
    name: " RHB Bank ",
    routing: " 100002186 ",
    ca: [{ exact: 14 }],
    sa: [{ exact: 14 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 14 }],
    hpAc: [{ exact: 12 }],
    deliveryChannel: " OTC, Internet, ATM "
  },
  {
    id: 36,
    name: " RHB Islamic Bank ",
    routing: " 100002186 ",
    ca: [{ exact: 14 }],
    sa: [{ exact: 14 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 14 }],
    hpAc: [{ exact: 12 }],
    deliveryChannel: " OTC, Internet, ATM "
  },
  {
    id: 37,
    name: " Standard Chartered Bank ",
    routing: " 100002144 ",
    ca: [
      { type: "personal", exact: 12 },
      { type: "corporate", min: 5, max: 17 }
    ],
    sa: [{ exact: 12 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 8 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet, Phone Banking "
  },
  {
    id: 38,
    name: " Standard Chartered Saadiq ",
    routing: " 100002144 ",
    ca: [
      { type: "personal", exact: 12 },
      { type: "corporate", min: 5, max: 17 }
    ],
    sa: [{ exact: 12 }],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [{ exact: 8 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet, Phone Banking "
  },
  {
    id: 39,
    name: " Sumitomo Mitsui Banking Corporation ",
    routing: " 100002623 ",
    ca: [{ exact: 8 }],
    sa: [],
    creditCardAc: [],
    chargeCardAc: [],
    loadAc: [],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  },
  {
    id: 40,
    name: " United Overseas Bank ",
    routing: " 100002267 ",
    ca: [
      { exact: 7 },
      { exact: 9 },
      { exact: 10 },
      { exact: 11 },
      { exact: 12 },
      { exact: 13 },
      { exact: 14 },
      { exact: 17 }
    ],
    sa: [{ exact: 10 }, { exact: 11 }],
    creditCardAc: [{ exact: 16 }],
    chargeCardAc: [],
    loadAc: [{ exact: 10 }, { exact: 15 }],
    hpAc: [],
    deliveryChannel: " OTC, Internet "
  }
];
</script>


// WEBPACK FOOTER //
// src/components/Param/IBG.vue